import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/AppShell";

export function AiChoice({ value, onChange }) {
  const opts = [[true, "Turn on AI coaching", "Your daily notes, letters and chats are written by CAMRYN's AI. Only the fields you allow in the Privacy Center are sent to our AI provider."],
    [false, "Not now", "CAMRYN uses simple built-in tips instead. You can switch AI on any time in the Privacy Center."]];
  return (
    <div className="space-y-2" data-testid="ai-choice">
      {opts.map(([v, l, d]) => (
        <button type="button" key={l} onClick={() => onChange(v)} data-testid={`ai-choice-${v ? "on" : "off"}`}
          className={`chip w-full text-left rounded-2xl border p-4 ${value === v ? "border-stone-900 bg-stone-900 text-white" : "border-stone-200 bg-white"}`}>
          <div className="font-semibold text-sm">{l}</div><div className={`text-xs mt-1 ${value === v ? "text-white/70" : "text-stone-500"}`}>{d}</div>
        </button>
      ))}
    </div>
  );
}

export const saveConsent = (ai) => api.post("/consent", { data_consent: true, ai_consent: ai });

export function ConsentGate() {
  const { user, refresh, logout } = useAuth();
  const [data, setData] = useState(false);
  const [ai, setAi] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try { await saveConsent(ai); await refresh(); } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <div className="grain min-h-screen">
      <div className="relative z-10 max-w-lg mx-auto px-6 py-12" data-testid="consent-gate">
        <Logo />
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight mt-10">A quick privacy check, {user.name?.split(" ")[0]}</h1>
        <p className="text-stone-600 mt-3 text-sm leading-relaxed">We've updated how CAMRYN asks for permission. Please confirm your choices. Nothing changes until you do, and you can change them any time.</p>
        <label className="flex gap-3 mt-6 text-sm items-start cursor-pointer card p-4">
          <input type="checkbox" checked={data} onChange={(e) => setData(e.target.checked)} data-testid="consent-gate-data" className="mt-1 accent-[#2D2926]" />
          <span>I agree that CAMRYN stores my wellness data (check-ins, cycle, weight, notes and journey) to personalise my experience, as described in the <Link to="/legal/health-data" className="underline">Health Data Policy</Link> and <Link to="/legal/privacy" className="underline">Privacy Policy</Link>.</span>
        </label>
        <div className="eyebrow mt-6 mb-2">AI coaching (separate choice)</div>
        <AiChoice value={ai} onChange={setAi} />
        <button disabled={!data || ai === null || busy} onClick={submit} data-testid="consent-gate-submit" className="btn-ink w-full h-12 rounded-full font-semibold mt-6 disabled:opacity-40">{busy ? "Saving…" : "Confirm and continue"}</button>
        <button onClick={logout} data-testid="consent-gate-signout" className="block mx-auto text-xs text-stone-500 mt-4">Sign out instead</button>
        <p className="text-[11px] text-stone-500 mt-4 text-center">Rather not continue? You can export or delete your data after confirming, in the Privacy Center.</p>
      </div>
    </div>
  );
}
